/* Casa Coton - suivi GA4 de l'option broderie prenom (tunnel de personnalisation).
   Aucune donnee personnelle n'est envoyee : le prenom saisi n'est JAMAIS transmis (seule sa presence compte).
   Chaque etape est envoyee UNE fois par page (drapeaux), meme si Dawn re-rend le formulaire. */
(function () {
  var GA4_ID = 'G-R99PBZRY0F';
  var sent = {};

  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    params = params || {};
    params.send_to = GA4_ID;
    try { window.gtag('event', name, params); } catch (e) {}
  }
  function once(name, params) {
    if (sent[name]) return;
    sent[name] = true;
    send(name, params);
  }

  function moduleOf(el) { return el && el.closest ? el.closest('cc-broderie') : null; }
  function isOn(root) { var chk = root.querySelector('.cc-brd__check'); return !!(chk && chk.checked); }
  function threadColor(root) { var c = root.querySelector('.cc-brd__swatch input:checked'); return c ? c.value : ''; }
  function nameLength(root) { var i = root.querySelector('.cc-brd__name'); return i ? i.value.trim().length : 0; }

  function colorIndex(p) {
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) { if (String(opts[i]).toLowerCase().indexOf('couleur') > -1) return i; }
    return -1;
  }
  function context(root) {
    var p = window.ccGA4Product || {};
    var id = root.getAttribute('data-form-id');
    var form = id ? document.getElementById(id) : null;
    var input = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
    var vid = input ? String(input.value) : '';
    var v = (p.variants && p.variants[vid]) || null;
    var price = v ? v.p : (p.price || 0);
    var ci = colorIndex(p);
    var color = (v && v.c) ? v.c : ((v && v.o && ci > -1) ? (v.o[ci] || '') : '');
    return {
      price: price, color: color, variant_id: vid,
      item: { item_id: p.id ? String(p.id) : '', item_name: p.title || root.getAttribute('data-product-title') || '', item_brand: 'Casa Coton', item_category: p.type || '', item_variant: v ? v.t : '', price: price, quantity: 1 }
    };
  }
  function payload(root, personalized) {
    var c = context(root);
    return {
      currency: 'EUR', value: c.price,
      personalized: personalized,
      personalization_enabled: personalized === 'yes',
      product_id: c.item.item_id,
      variant_id: c.variant_id,
      garment_color: c.color,
      thread_color: threadColor(root),
      name_length: nameLength(root),
      items: [c.item]
    };
  }

  function engage(root) { once('personalization_engaged', payload(root, isOn(root) ? 'yes' : 'no')); }
  function checkComplete(root) {
    if (isOn(root) && nameLength(root) >= 2) once('personalization_complete', payload(root, 'yes'));
  }

  document.addEventListener('pointerdown', function (e) { var root = moduleOf(e.target); if (root) engage(root); }, true);
  document.addEventListener('focusin', function (e) { var root = moduleOf(e.target); if (root) engage(root); }, true);

  document.addEventListener('input', function (e) {
    var root = moduleOf(e.target);
    if (!root || !e.target.classList || !e.target.classList.contains('cc-brd__name')) return;
    if (nameLength(root) >= 2) { once('personalization_name_entered', payload(root, 'yes')); checkComplete(root); }
  }, true);

  document.addEventListener('change', function (e) {
    var root = moduleOf(e.target);
    if (!root) return;
    engage(root);
    var t = e.target;
    if (t.classList && t.classList.contains('cc-brd__check') && t.checked) {
      once('personalization_selected', payload(root, 'yes'));
      checkComplete(root);
    }
    if (t.type === 'radio' && t.closest('.cc-brd__swatch')) {
      once('personalization_thread_selected', payload(root, isOn(root) ? 'yes' : 'no'));
      checkComplete(root);
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var fid = form.getAttribute('id');
    if (!fid) return;
    var roots = document.querySelectorAll('cc-broderie');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-form-id') === fid && isOn(roots[i]) && nameLength(roots[i]) > 0) {
        send('personalization_confirmed', payload(roots[i], 'yes'));
        sent.personalization_confirmed = true;
        return;
      }
    }
  }, true);

  /* Abandon : la broderie a ete activee mais aucun ajout au panier avec broderie avant de quitter la page. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'hidden') return;
    if (!sent.personalization_selected || sent.personalization_confirmed) return;
    var root = document.querySelector('cc-broderie');
    if (root) once('personalization_abandoned', payload(root, isOn(root) ? 'yes' : 'no'));
  });
})();
